import { getMobileOperatingSystem } from "utils/dom.util";

/** Original iOS capture quality — unchanged to avoid regressions. */
export const CAPTURE_JPEG_QUALITY_IOS = 0.7;

/** Higher JPEG quality for flat Android Chrome frames (BMT-361). */
export const CAPTURE_JPEG_QUALITY_ANDROID = 0.92;

const BASE_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  width: { ideal: 720 },
  height: { ideal: 720 },
  facingMode: { ideal: "environment" },
  frameRate: { max: 12 },
};

const ANDROID_VIDEO_CONSTRAINTS = {
  ...BASE_VIDEO_CONSTRAINTS,
  exposureMode: "continuous",
  whiteBalanceMode: "continuous",
} as MediaTrackConstraints;

export const getCaptureJpegQuality = (): number => {
  return getMobileOperatingSystem() === "Android"
    ? CAPTURE_JPEG_QUALITY_ANDROID
    : CAPTURE_JPEG_QUALITY_IOS;
};

export const getCameraVideoConstraints = (): MediaTrackConstraints => {
  if (getMobileOperatingSystem() === "Android") {
    return ANDROID_VIDEO_CONSTRAINTS;
  }

  return BASE_VIDEO_CONSTRAINTS;
};

export const shouldEnhanceCapturedContrast = (): boolean => {
  return getMobileOperatingSystem() === "Android";
};
